module.exports = __webpack_public_path__ + "img/2 s.e2640082.jpg";